import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import logoClaro from "./logo-claro.png";

const SIDEBAR_WIDTH_EXPANDED  = "240px";
const SIDEBAR_WIDTH_COLLAPSED = "68px";
const CLARO_RED   = "#E30613";
const CLARO_DARK  = "#0f172a";
const CLARO_GRAY  = "#1e293b";
const CLARO_MUTED = "#64748b";

// ── Íconos SVG inline ──────────────────────────────────────────
const Icon = ({ d, size = 16, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0 }}>
    <path d={d} />
  </svg>
);

const ICONS = {
  home:     "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10",
  reportes: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
  panel:    "M18 20V10 M12 20V4 M6 20v-6",
  resumen:  "M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z",
  causas:   "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  planes:   "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2 M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2",
  semaforo: "M12 2a7 7 0 0 1 7 7v1a7 7 0 0 1-14 0V9a7 7 0 0 1 7-7z M12 6v.01 M12 10v.01 M12 14v.01",
  concilia: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2 M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2 M9 12l2 2 4-4",
  huella:   "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  calidad:  "M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z", // ── NUEVO
  escalamientos: "M22 2L11 13 M22 2l-7 20-4-9-9-4 20-7z", // ── NUEVO: Escalamientos
  gestion:  "M12 20h9 M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z",
  cargar:   "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M17 8l-5-5-5 5 M12 3v12",
  usuarios: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
  key:      "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4",
  logout:   "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9",
  backlog:  "M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11", // ── NUEVO
};

// ── Estructura de menús agrupados ─────────────────────────────
const MENU_GRUPOS = [
  {
    id: "general",
    label: "General",
    color: "#94a3b8",
    items: [
      { path: "/",             label: "Home",                icon: "home"     },
      { path: "/reportes",     label: "Reporte Ofensores",   icon: "reportes" },
      { path: "/ofensores-n2",      label: "Panel Ofensores N2+",      icon: "panel"    },
      { path: "/conciliaciones",     label: "Conciliaciones Ofensores", icon: "concilia" },
      { path: "/resumen-icr",  label: "Resumen ICR",         icon: "resumen"  },
      { path: "/causas-falla", label: "Causas de Falla",     icon: "causas"   },
      { path: "/planes",       label: "Planes de Trabajo",   icon: "planes"   },
      { path: "/semaforo",     label: "Semáforo Nodos",      icon: "semaforo" },
    ],
  },
  {
    id: "huella",
    label: "Proyecto Huella",
    color: "#60a5fa",
    items: [
      { path: "/priorizacion-huella", label: "Priorización Huella", icon: "huella" },
      { path: "/calidad-huella",      label: "Calidad Nodos Huella", icon: "calidad" }, // ── NUEVO
      { path: "/escalamientos",       label: "Escalamientos",        icon: "escalamientos" }, // ── NUEVO
    ],
  },
  {
    id: "backlog", // ── NUEVO: sección propia, igual que Proyecto Huella
    label: "Backlog R3",
    color: "#fbbf24",
    items: [
      { path: "/backlog-r3", label: "Backlog OM Fijo R3", icon: "backlog" },
    ],
  },
];

const MENU_ADMIN = {
  id: "admin",
  label: "Administración",
  color: "#f87171",
  items: [
    { path: "/gestion-huella", label: "Gestión Huella",        icon: "gestion"  },
    { path: "/cargar",         label: "Cargar Disponibilidad", icon: "cargar"   },
    { path: "/cargar-backlog", label: "Cargar Backlog R3",     icon: "cargar"   }, // ── NUEVO
    { path: "/usuarios",       label: "Gestión Usuarios",      icon: "usuarios" },
  ],
};

function DashboardLayout({ children, usuario, onLogout }) {
  const location = useLocation();
  const esAdmin  = (usuario?.rol || "").toLowerCase() === "administrador";
  const grupos   = esAdmin ? [...MENU_GRUPOS, MENU_ADMIN] : MENU_GRUPOS;

  const [colapsado, setColapsado]         = useState(false);
  const [gruposAbiertos, setGruposAbiertos] = useState(grupos.map(g => g.id));
  const sidebarWidth = colapsado ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;

  const toggleGrupo = (id) =>
    setGruposAbiertos(prev =>
      prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id]
    );

  const [showModal, setShowModal]     = useState(false);
  const [passActual, setPassActual]   = useState("");
  const [passNueva, setPassNueva]     = useState("");
  const [passConfirm, setPassConfirm] = useState("");
  const [passError, setPassError]     = useState("");
  const [passExito, setPassExito]     = useState("");
  const [passLoading, setPassLoading] = useState(false);

  const handleCambiarPass = async (e) => {
    e.preventDefault();
    setPassError(""); setPassExito("");
    if (passNueva !== passConfirm) { setPassError("Las contraseñas no coinciden."); return; }
    if (passNueva.length < 6) { setPassError("La nueva contraseña debe tener al menos 6 caracteres."); return; }
    setPassLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/cambiar-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cedula: usuario?.cedula, password_actual: passActual, nueva_password: passNueva })
      });
      const data = await res.json();
      if (data.ok) {
        setPassExito("Contraseña cambiada correctamente.");
        setPassActual(""); setPassNueva(""); setPassConfirm("");
        setTimeout(() => { setShowModal(false); setPassExito(""); }, 2000);
      } else {
        setPassError(data.mensaje || "Error al cambiar contraseña.");
      }
    } catch {
      setPassError("No se pudo conectar con el servidor.");
    } finally {
      setPassLoading(false);
    }
  };

  // ── Render ítem ────────────────────────────────────────────────
  const renderItem = (item, accentColor = "#94a3b8") => {
    const activo = location.pathname === item.path;
    return (
      <Link key={item.path} to={item.path} style={{ textDecoration: "none" }}>
        <div
          title={colapsado ? item.label : undefined}
          style={{
            display: "flex", alignItems: "center",
            gap: colapsado ? 0 : "10px",
            padding: colapsado ? "10px 0" : "8px 12px 8px 14px",
            justifyContent: colapsado ? "center" : "flex-start",
            margin: "1px 6px",
            borderRadius: "8px",
            background: activo
              ? `linear-gradient(135deg, ${CLARO_RED}ee, #B0000E)`
              : "transparent",
            cursor: "pointer",
            transition: "all 0.15s ease",
            position: "relative",
            boxShadow: activo ? `0 2px 10px ${CLARO_RED}40` : "none",
          }}
          onMouseEnter={e => { if (!activo) e.currentTarget.style.background = "rgba(255,255,255,0.06)"; }}
          onMouseLeave={e => { if (!activo) e.currentTarget.style.background = "transparent"; }}
        >
          {/* Barra indicador izquierda */}
          {activo && !colapsado && (
            <div style={{
              position: "absolute", left: 0, top: "7px", bottom: "7px",
              width: "3px", borderRadius: "0 3px 3px 0",
              background: "rgba(255,255,255,0.5)",
            }} />
          )}
          {/* Ícono */}
          <div style={{ color: activo ? "white" : accentColor, display: "flex", alignItems: "center", opacity: activo ? 1 : 0.8 }}>
            <Icon d={ICONS[item.icon] || ICONS.home} size={15} stroke={activo ? "white" : accentColor} />
          </div>
          {/* Texto */}
          {!colapsado && (
            <span style={{
              color: activo ? "white" : "#cbd5e1",
              fontSize: "12.5px", fontWeight: activo ? "600" : "400",
              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              letterSpacing: "0.01em",
            }}>
              {item.label}
            </span>
          )}
        </div>
      </Link>
    );
  };

  // ── Render grupo desplegable ───────────────────────────────────
  const renderGrupo = (grupo) => {
    const abierto     = gruposAbiertos.includes(grupo.id);
    const tieneActivo = grupo.items.some(i => i.path === location.pathname);

    return (
      <div key={grupo.id} style={{ marginBottom: "2px" }}>
        {/* Cabecera grupo */}
        {!colapsado ? (
          <div
            onClick={() => toggleGrupo(grupo.id)}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "6px 14px 6px 12px",
              margin: "4px 6px 2px 6px",
              cursor: "pointer", borderRadius: "6px",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.04)"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div style={{
                width: "3px", height: "14px", borderRadius: "2px",
                background: tieneActivo ? grupo.color : grupo.color + "50",
              }} />
              <span style={{
                fontSize: "9.5px", fontWeight: "700", color: grupo.color,
                textTransform: "uppercase", letterSpacing: "0.1em",
              }}>
                {grupo.label}
              </span>
            </div>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
              stroke={grupo.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
              style={{ transition: "transform 0.2s", transform: abierto ? "rotate(90deg)" : "rotate(0deg)", opacity: 0.6 }}>
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </div>
        ) : (
          <div style={{ margin: "6px 14px", borderTop: `1px solid ${grupo.color}25` }} />
        )}

        {/* Items con animación */}
        <div style={{
          overflow: "hidden",
          maxHeight: abierto || colapsado ? "600px" : "0px",
          transition: "max-height 0.25s ease",
        }}>
          {grupo.items.map(item => renderItem(item, grupo.color))}
        </div>
      </div>
    );
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>

      {/* ════════════════ SIDEBAR ════════════════ */}
      <div style={{
        width: sidebarWidth,
        background: "linear-gradient(180deg, #0d1829 0%, #0f172a 55%, #0c1420 100%)",
        position: "fixed", top: 0, left: 0, height: "100vh",
        overflowY: "auto", overflowX: "hidden",
        zIndex: 200,
        borderRight: "1px solid rgba(255,255,255,0.05)",
        display: "flex", flexDirection: "column",
        transition: "width 0.25s ease",
        boxShadow: "4px 0 20px rgba(0,0,0,0.25)",
      }}>

        {/* Botón toggle — hamburger prominente */}
        <button
          onClick={() => setColapsado(c => !c)}
          title={colapsado ? "Expandir menú" : "Colapsar menú"}
          style={{
            position: "absolute", top: "18px", right: "-22px",
            width: "44px", height: "44px", borderRadius: "12px",
            background: `linear-gradient(135deg, #1e293b, #0f172a)`,
            border: `2px solid ${CLARO_RED}`,
            cursor: "pointer", padding: 0,
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", gap: "6px",
            zIndex: 300,
            boxShadow: `0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px ${CLARO_RED}30`,
            transition: "all 0.2s ease",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = `linear-gradient(135deg, ${CLARO_RED}, #B0000E)`;
            e.currentTarget.style.boxShadow = `0 6px 20px ${CLARO_RED}60`;
            e.currentTarget.style.transform = "scale(1.08)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "linear-gradient(135deg, #1e293b, #0f172a)";
            e.currentTarget.style.boxShadow = `0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px ${CLARO_RED}30`;
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <div style={{ height: "2.5px", borderRadius: "3px", background: "white", width: colapsado ? "20px" : "24px", transition: "width 0.25s ease" }} />
          <div style={{ height: "2.5px", borderRadius: "3px", background: "white", width: "24px" }} />
          <div style={{ height: "2.5px", borderRadius: "3px", background: "white", width: colapsado ? "24px" : "20px", transition: "width 0.25s ease" }} />
        </button>

        {/* Header / Logo */}
        <div style={{
          padding: colapsado ? "16px 0" : "14px 18px",
          borderBottom: "1px solid rgba(255,255,255,0.05)",
          display: "flex", alignItems: "center",
          justifyContent: colapsado ? "center" : "flex-start",
          gap: "10px", minHeight: "70px",
          background: "rgba(0,0,0,0.15)",
        }}>
          {/* Logo Claro Colombia */}
          <img
            src={logoClaro}
            alt="Claro Colombia"
            style={{
              width: colapsado ? "36px" : "40px",
              height: colapsado ? "36px" : "40px",
              objectFit: "contain",
              flexShrink: 0,
              borderRadius: "8px",
              background: "rgba(255,255,255,0.06)",
              padding: "4px",
            }}
          />
          {!colapsado && (
            <div style={{ overflow: "hidden" }}>
              <div style={{
                color: "white", fontWeight: "700", fontSize: "13px",
                letterSpacing: "0.02em", whiteSpace: "nowrap",
              }}>
                ICR Ofensores R3
              </div>
              <div style={{
                color: "#475569", fontSize: "10px",
                marginTop: "2px", whiteSpace: "nowrap",
              }}>
                Claro Colombia
              </div>
            </div>
          )}
        </div>

        {/* Navegación */}
        <nav style={{ flex: 1, padding: "10px 0", overflowY: "auto", overflowX: "hidden" }}>
          {grupos.map(g => renderGrupo(g))}
        </nav>

        {/* Footer usuario */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", background: "rgba(0,0,0,0.15)" }}>

          {/* Info usuario */}
          {usuario && (
            <div style={{
              padding: colapsado ? "12px 0" : "12px 14px",
              display: "flex", alignItems: "center",
              justifyContent: colapsado ? "center" : "flex-start",
              gap: "10px",
              borderBottom: "1px solid rgba(255,255,255,0.04)",
            }}>
              {/* Avatar con inicial */}
              <div style={{
                width: "34px", height: "34px", borderRadius: "10px",
                background: `linear-gradient(135deg, ${CLARO_RED}bb, #7c3aed)`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "14px", fontWeight: "800", color: "white",
                flexShrink: 0, boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
              }}>
                {(usuario.nombre || usuario.usuario || "?")[0].toUpperCase()}
              </div>
              {!colapsado && (
                <div style={{ overflow: "hidden", flex: 1 }}>
                  <div style={{ fontSize: "12px", color: "#f1f5f9", fontWeight: "600", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {usuario.nombre || usuario.usuario}
                  </div>
                  <div style={{ fontSize: "10px", color: CLARO_RED, fontWeight: "600", marginTop: "1px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {usuario.rol}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Botones */}
          <div style={{ padding: colapsado ? "10px 8px" : "10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <button
              onClick={() => { setShowModal(true); setPassError(""); setPassExito(""); }}
              title="Cambiar contraseña"
              style={{
                width: "100%", padding: "8px 10px",
                background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "8px", color: "#94a3b8", fontSize: "11.5px", fontWeight: "500",
                cursor: "pointer", display: "flex", alignItems: "center",
                justifyContent: colapsado ? "center" : "flex-start", gap: "8px",
                transition: "all 0.15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.09)"; e.currentTarget.style.color = "#e2e8f0"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; e.currentTarget.style.color = "#94a3b8"; }}
            >
              <Icon d={ICONS.key} size={14} stroke="#94a3b8" />
              {!colapsado && "Cambiar contraseña"}
            </button>
            <button
              onClick={onLogout}
              title="Cerrar sesión"
              style={{
                width: "100%", padding: "8px 10px",
                background: "rgba(227,6,19,0.08)", border: "1px solid rgba(227,6,19,0.18)",
                borderRadius: "8px", color: "#f87171", fontSize: "11.5px", fontWeight: "600",
                cursor: "pointer", display: "flex", alignItems: "center",
                justifyContent: colapsado ? "center" : "flex-start", gap: "8px",
                transition: "all 0.15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(227,6,19,0.18)"; e.currentTarget.style.color = "#fca5a5"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(227,6,19,0.08)"; e.currentTarget.style.color = "#f87171"; }}
            >
              <Icon d={ICONS.logout} size={14} stroke="#f87171" />
              {!colapsado && "Cerrar sesión"}
            </button>
          </div>
        </div>

      </div>

      {/* ════════════════ CONTENIDO PRINCIPAL ════════════════ */}
      <div style={{ marginLeft: sidebarWidth, flex: 1, background: "#f1f5f9", minHeight: "100vh", transition: "margin-left 0.25s ease" }}>

        {/* Topbar */}
        <div style={{
          position: "fixed", top: 0, left: sidebarWidth, right: 0, height: "52px",
          transition: "left 0.25s ease",
          background: "white", borderBottom: "1px solid #e2e8f0",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0 24px", zIndex: 100,
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: "3px", height: "20px", background: CLARO_RED, borderRadius: "2px" }} />
            <h3 style={{ margin: 0, fontSize: "15px", color: CLARO_DARK, fontWeight: "600" }}>Panel de Control</h3>
          </div>
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "20px", padding: "4px 14px", fontSize: "12px", color: CLARO_RED, fontWeight: "600" }}>
            ICR Ofensores R3
          </div>
        </div>

        <div style={{ padding: "72px 24px 24px 24px" }}>
          {children}
        </div>
      </div>

      {/* ════════════════ MODAL CAMBIAR CONTRASEÑA ════════════════ */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "white", borderRadius: "16px", padding: "32px", width: "100%", maxWidth: "400px", margin: "20px", boxShadow: "0 24px 80px rgba(0,0,0,0.4)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ margin: 0, color: CLARO_DARK, fontSize: "18px", fontWeight: "700" }}>Cambiar contraseña</h3>
              <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: CLARO_MUTED, lineHeight: 1 }}>✕</button>
            </div>
            <form onSubmit={handleCambiarPass} style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              {[
                { label: "Contraseña actual",          val: passActual,  set: setPassActual,  ph: "Tu contraseña actual"       },
                { label: "Nueva contraseña",           val: passNueva,   set: setPassNueva,   ph: "Mínimo 6 caracteres"        },
                { label: "Confirmar nueva contraseña", val: passConfirm, set: setPassConfirm, ph: "Repite la nueva contraseña" },
              ].map(({ label, val, set, ph }) => (
                <div key={label}>
                  <label style={{ display: "block", fontSize: "11px", fontWeight: "700", color: CLARO_MUTED, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>{label}</label>
                  <input type="password" value={val} onChange={e => set(e.target.value)} placeholder={ph}
                    style={{ width: "100%", boxSizing: "border-box", padding: "11px 14px", border: "2px solid #e2e8f0", borderRadius: "10px", fontSize: "13px", color: CLARO_DARK, background: "#f8fafc", outline: "none" }}
                    onFocus={e => e.target.style.borderColor = CLARO_RED}
                    onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
                </div>
              ))}
              {passError && <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "10px 14px", color: "#991b1b", fontSize: "13px" }}>{passError}</div>}
              {passExito && <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", padding: "10px 14px", color: "#15803d", fontSize: "13px" }}>{passExito}</div>}
              <div style={{ display: "flex", gap: "10px", marginTop: "4px" }}>
                <button type="button" onClick={() => setShowModal(false)}
                  style={{ flex: 1, padding: "11px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: "pointer", color: CLARO_MUTED }}>
                  Cancelar
                </button>
                <button type="submit" disabled={passLoading}
                  style={{ flex: 1, padding: "11px", background: passLoading ? "#9ca3af" : `linear-gradient(135deg, ${CLARO_RED}, #B0000E)`, color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "700", cursor: passLoading ? "not-allowed" : "pointer" }}>
                  {passLoading ? "Guardando..." : "Guardar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

export default DashboardLayout;